//AES加密
import CryptoJS from "crypto-js";
var aesKey = 'L/MNDZpEZIV95VDD'
var appId = "XSZY80d28e0682f846ee";

export default {
    //加密
    encryptFun(data, key) {
        var key = CryptoJS.enc.Utf8.parse(key || aesKey);
        var options = {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        };
        var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), key, options);
        var encryptResult = encryptedData.toString();
        return encryptResult;
    },

    //解密
    decrypt(data) {
        var key = CryptoJS.enc.Utf8.parse(aesKey);
        var options = {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        };
        var decryptedData = CryptoJS.AES.decrypt(data, key, options);
        var decryptResult = JSON.parse(decryptedData.toString(CryptoJS.enc.Utf8));
        return decryptResult;
    },

    encrypt(obj, iAppId, key) {
        let dateOffset = localStorage.getItem('dateOffset')
        let obj1 = {
            appId: iAppId || appId,
            timestamp: new Date().getTime() + (dateOffset ? dateOffset * 1 : 0)
        }
        let d = Object.assign({}, obj, obj1)
        let params = this.encryptFun(d, key);
        let newObj = {
            params
        }
        if (window.config.debug) {
            newObj["请求参数"] = d
        }
        return newObj
    }
}